// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { CHECK_PAYMENT_SERVICE_CONFIGURATION } from './constants/payment-landing-form.services.constants';
// Types
import {
  CheckPaymentReturnType,
  CheckPaymentType,
} from '../handlers/utils/types/payment-landing-form.handlers.utils.type';

const checkPaymentService = async ({
  brand,
  country,
  funding,
  monthExp,
  yearExp,
}: CheckPaymentType): Promise<[CheckPaymentReturnType, Response]> =>
  apiUtils.post({
    ...CHECK_PAYMENT_SERVICE_CONFIGURATION,
    params: { brand, country, funding, monthExp, yearExp },
  });

export { checkPaymentService };
